<template>
  <div>
    <populate-form
      formTitle="店家劃位設定管理"
      fkey="mm01"
      ref="filterStoreForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
      :validatePrompt="false"
      :parentVue="this"
      @customValueChanged="filterChanged"
    ></populate-form>
    <div v-if="StoreSetting">
      <populate-form
        formTitle="店家劃位設定"
        fkey="sc01"
        ref="storeConfigForm"
        populateOptionVar="storeConfigOptions"
        formDataObjVar="StoreSetting"
        :parentVue="this"
        @customValueChanged="settingChanged"
      ></populate-form>
      <b-button class="mr-2" @click="restoreSetting">取消</b-button>
      <b-button @click="setStoreSetting">{{StoreRuleIsSet?'更新設定':'建立新設定'}}</b-button>
    </div>
    <div v-if="!StoreSetting">
      請先用關鍵字找到店家
    </div>
  </div>
</template>

<script>

import StoreInfo from './StoreInfo'

export default {
  name: 'StoreManage',
  components: {
    /* eslint-disable vue/no-unused-components */
    StoreInfo,
  },
  data: function () {
    return {
      showModal:false,
      Stores:[],
      StoreSetting:null,
      StoreSettingBack:null,
      storeConfigOptions:[
        {
          componentType:'span',
          col:2,
          placeholder:'開放起訖：'
        },
        {
          componentType:'span',
          col:2,
          placeholder:'提前'
        },
        {
          componentType:'number',
          akey:'min_pre_reserve_days',
          col:2,
          placeholder:''
        },
        {
          componentType:'span',
          col:2,
          placeholder:'天,開放'
        },
        {
          componentType:'number',
          akey:'max_open_reserve_days',
          col:2,
          placeholder:''
        },
        {
          componentType:'span',
          col:2,
          placeholder:'天內'
        },
        {
          componentType:'span',
          col:2,
          placeholder:'最小時間單位:',
          title:"店家時段的最小單位,若為30則店家時段都是30的整數,不能預約不是:00/:30的如:20這樣的其他時間",
        },
        {
          componentType:'b-form-select',
          col:2,
          akey:"service_minute_unit",
          defaultValue:"30",
          dataOptions:[{text:"30分鐘",value:"30"},{text:"15分鐘",value:"15"},{text:"10分鐘",value:"10"},{text:"一小時",value:"60"}],
          dynamicDisabled:this.isEditExistedStoreRule
        },
        {
          componentType:'span',
          col:8,
        },
        {
          componentType:'span',
          col:2,
          placeholder:'取消劃位設定：'
        },
        {
          componentType:'span',
          col:2,
          placeholder:'預取消天數'
        },
        {
          componentType:'number',
          col:2,
          akey:'auto_cancel_min_days',
          placeholder:'幾天以內的劃位不能自動接受取消',
          title:'自動接受劃位的預約原則上自動接受取消,未提前超過此天數時一律需要店家確認取消',
        },
        {
          componentType:'span',
          col:2,
          placeholder:'自動接受'
        },
        {
          componentType:'b-form-checkbox',
          col:1,
          akey:'auto_cancel_for_negotiate_reserve',
          title:'若勾選,用戶取消劃位均無須店家店家逐一確認,除非近於前一個參數天數,若未勾選,則非經店家人工確認接受的劃位均需人工確認取消'
        },
        {
          componentType:'span',
          col:3
        },
        {
          componentType:'span',
          col:2,
          placeholder:'交談與好友:'
        },
        {
          componentType:'span',
          col:2,
          placeholder:'自動接受任何對話'
        },
        {
          componentType:'b-form-checkbox',
          col:2,
          akey:'accept_any_contact',
          title:'若勾選則沒有相關課程票券也不是好友的用戶亦可進行留言對話,反之則不接受留言對話'
        },
        {
          componentType:'span',
          col:2,
          placeholder:'自動接受好友邀請'
        },
        {
          componentType:'b-form-checkbox',
          col:1,
          akey:'auto_accept_friend_invite',
          title:'若勾選則沒有相關課程票券也不是好友的用戶亦可進行留言對話,反之則不接受留言對話'
        },
        {
          componentType:'span',
          col:3
        },
        {
          componentType:'span',
          col:12,
          placeholder:'營業時間：'
        },
        {
          componentType:"span",
          col:3,
          placeholder:"週日"
        },
        {
          componentType:"vue-timepicker",
          akey:'starttime_day0',
          col:3,
          placeholder:"開始時間"
        },
        {
          componentType:"vue-timepicker",
          akey:'endtime_day0',
          col:3,
          placeholder:"結束時間"
        },
        {
          componentType:"span",
          col:3,
          placeholder:""
        },
        {
          componentType:"span",
          col:3,
          placeholder:"週一"
        },
        {
          componentType:"vue-timepicker",
          akey:'starttime_day1',
          col:3,
          placeholder:"開始時間"
        },
        {
          componentType:"vue-timepicker",
          akey:'endtime_day1',
          col:3,
          placeholder:"結束時間"
        },
        {
          componentType:"b-button",
          akey:'cpbtn_1',
          col:2,
          placeholder:"複製前一天",
          execCallback:this.copyDateConfig
        },
        {
          componentType:"span",
          col:3,
          placeholder:"週二"
        },
        {
          componentType:"vue-timepicker",
          akey:'starttime_day2',
          col:3,
          placeholder:"開始時間"
        },
        {
          componentType:"vue-timepicker",
          akey:'endtime_day2',
          col:3,
          placeholder:"結束時間"
        },
        {
          componentType:"b-button",
          akey:'cpbtn_2',
          col:2,
          placeholder:"複製前一天",
          execCallback:this.copyDateConfig
        },
        {
          componentType:"span",
          col:3,
          placeholder:"週三"
        },
        {
          componentType:"vue-timepicker",
          akey:'starttime_day3',
          col:3,
          placeholder:"開始時間"
        },
        {
          componentType:"vue-timepicker",
          akey:'endtime_day3',
          col:3,
          placeholder:"結束時間"
        },
        {
          componentType:"b-button",
          akey:'cpbtn_3',
          col:2,
          placeholder:"複製前一天",
          execCallback:this.copyDateConfig
        },
        {
          componentType:"span",
          col:3,
          placeholder:"週四"
        },
        {
          componentType:"vue-timepicker",
          akey:'starttime_day4',
          col:3,
          placeholder:"開始時間"
        },
        {
          componentType:"vue-timepicker",
          akey:'endtime_day4',
          col:3,
          placeholder:"結束時間"
        },
        {
          componentType:"b-button",
          akey:'cpbtn_4',
          col:2,
          placeholder:"複製前一天",
          execCallback:this.copyDateConfig
        },
        {
          componentType:"span",
          col:3,
          placeholder:"週五"
        },
        {
          componentType:"vue-timepicker",
          akey:'starttime_day5',
          col:3,
          placeholder:"開始時間"
        },
        {
          componentType:"vue-timepicker",
          akey:'endtime_day5',
          col:3,
          placeholder:"結束時間"
        },
        {
          componentType:"b-button",
          akey:'cpbtn_5',
          col:2,
          placeholder:"複製前一天",
          execCallback:this.copyDateConfig
        },
        {
          componentType:"span",
          col:3,
          placeholder:"週六"
        },
        {
          componentType:"vue-timepicker",
          akey:'starttime_day6',
          col:3,
          placeholder:"開始時間"
        },
        {
          componentType:"vue-timepicker",
          akey:'endtime_day6',
          col:3,
          placeholder:"結束時間"
        },
        {
          componentType:"b-button",
          akey:'cpbtn_6',
          col:2,
          placeholder:"複製前一天",
          execCallback:this.copyDateConfig
        },
        {
          componentType:'span',
          col:3,
          placeholder:'最晚預約時間:'
        },
        {
          componentType:'vue-timepicker',
          col:3,
          akey:'store_last_reserve_time',
          placeholder:'最晚預約',
          title:'如課程無例外設定,此店家接受用戶劃位的開始時間選項最晚不會超過此時間'
        },
        {
          componentType:'span',
          col:6,
        },
        {
          componentType:'span',
          col:12,
          placeholder:' '
        },
        
      ],
      filterData: {},
      filterOptions:[
        {
          componentType:'vue-single-select',
          optionVar:'Stores',
          asyncFetchCB: this.loadStoreByKeyword,
          defaultValue:null,
          akey:'SelectedStoreItem',
          optionLabel:'select_text',
          col:12,
          placeholder:'選擇店家(輸入至少一個字的店家名稱關鍵字或SPS編號帶出選項,按Esc可清除全部關鍵字)',
        },
      ],
      store_id:0,
    }
  },
  methods: {
    isEditExistedStoreRule() {
      return this.setting_id > 0
    },
    copyDateConfig(evt) {
      // 複製上一天的營業起訖時間,因為timepicker畢竟不好按
      if (evt.target.id) {
        let parts = evt.target.id.split('_')
        let to = parts[parts.length-1]
        if (this.StoreSetting && to >= '1') {
          let from  = parseInt(to) - 1
          this.StoreSetting['starttime_day'+to] = this.StoreSetting['starttime_day'+from]
          this.StoreSetting['endtime_day'+to] = this.StoreSetting['endtime_day'+from]
        }
        this.$refs.storeConfigForm.refreshModelVar()
      }
    },
    restoreSetting() {
      this.StoreSetting = this.CpObj(this.StoreSettingBack)
      setTimeout(() => {
        this.$refs.storeConfigForm.refreshModelVar()
      }, 200);
    },
    setStoreSetting() {
      //新增或保存一個店家的劃位設定
      let Param = {
        'module':'store_admin',
        'method':'setStoreServiceRule',
      }
      Param = {...Param,...this.StoreSetting}
      Param.auto_cancel_for_negotiate_reserve = Param.auto_cancel_for_negotiate_reserve?1:0
      Param.auto_accept_friend_invite = Param.auto_accept_friend_invite?1:0
      Param.accept_any_contact = Param.accept_any_contact?1:0
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          vm.$bus.fnShowInfo("設定成功")
          vm.filterData.SelectedStoreItem = null
          vm.$refs.filterStoreForm.refreshModelVar()
          vm.StoreSetting = null
      },this)
    },
    settingChanged(upd) {
      if (upd.key === 'service_minute_unit') {
        this.resetTimeInterval(upd.val)
      }
    },
    resetTimeInterval(interval) {
      if (!interval) {
        interval = 1
      }
      for (let i=0;i<this.storeConfigOptions.length;i++) {
        if (this.storeConfigOptions[i].componentType === 'vue-timepicker') {
          this.storeConfigOptions[i].minuteInterval = parseInt(interval)
        }
      }
      // 因為連同filterOptions都要重抓所以就全部重畫
      this.$refs.storeConfigForm.$forceUpdate()
    },
    loadStoreByKeyword (keyword) {
      if (!keyword) {
        // 有填至少一個關鍵字才回傳選項
        this.Stores = []
        return
      }
      let Param = {
        'module':'admin_manage',
        'method':'getStoreAutoComplete',
        'keyword':keyword,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          vm.Stores = data.data.matched_store_list
      },this)
    },
    filterChanged (upd) {
      if (upd.key === 'SelectedStoreItem') {
        if (upd.val) {
              setTimeout(() => {
            this.loadStoreSettings(upd.val.id)
          }, 50);
        }
        else {
          this.StoreSettingBack = null
          this.StoreSetting = null
          this.setting_id = 0
        }
      }
      
    },
    loadStoreSettings(store_id) {
      let Param = {
        'module':'store_admin',
        'method':'getStoreServiceRuleByStoreId',
        'store_id':store_id,
      }
      this.$bus.apiCall(Param, function (data, vm) {
        if (data.ok === 0) {
            vm.$bus.fnShowInfo('呼叫失敗:'+data.msg)
            return
          }
          vm.StoreSetting = vm.setDefault(data.data, store_id)
          vm.StoreSettingBack = vm.CpObj(vm.StoreSetting)
          setTimeout(() => {
            vm.resetTimeInterval(vm.StoreSetting.service_minute_unit)
            //vm.$refs.storeConfigForm.$forceUpdate()
          }, 200);
      },this)
    },
    setDefault(setting, store_id) {
      setting.merchant_store_id = store_id
      // 尚未設定的店家給預設值避免一開始空的要按很久
      if (!setting.id) {
        setting.min_pre_reserve_days = 6
        setting.max_open_reserve_days = 14
        setting.service_minute_unit = '30'
        setting.store_last_reserve_time = "19:00"
        setting.auto_cancel_min_days = 7
        setting.auto_cancel_for_negotiate_reserve = 0
        setting.accept_any_contact = 0
        setting.auto_accept_friend_invite = 0
        setting.starttime_day0 = "11:00"
        setting.endtime_day0 = "21:00"
      }
      this.setting_id = setting.id?setting.id:0
      for (let i=0;i<this.storeConfigOptions.length;i++) {
        if (this.storeConfigOptions[i].dynamicHide !== undefined) {
          this.storeConfigOptions[i].hide = this.storeConfigOptions[i].dynamicHide()
        }
        if (this.storeConfigOptions[i].dynamicDisabled !== undefined) {
          this.storeConfigOptions[i].disabled = this.storeConfigOptions[i].dynamicDisabled()
        }
      }
      return setting
    }
  },
  computed:{
    StoreRuleIsSet: {
      cache: false,
      get () {
        if (this.StoreSetting && this.StoreSetting.hasOwnProperty('id')) {
          return true
        }
        else {
          return false
        }
      }
    },
  },
  created () {
    if (!this.$bus.session) {
      this.$bus.session = undefined
    }
  },
  mounted () {
    // 未初始化時預設值會是undefined,需注意呼叫api的參數處理
    this.$refs.filterStoreForm.initDefault()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
